export const CustomerConst = {
    IDENTITY_DOCUMENT: {
        SIGNATURE: "SIGNATURE",
        FOREIGN: "FOREIGN_PASSPORT",
        PASSPORT: "PASSPORT",
        SSC: "SSC",
        ID_CARD: "ID_CARD",
        OTHER: "OTHER"
    },
    IDENTITY_TYPE: {
        ID_CARD: "ID_CARD",
        NATIONAL_PASSPORT: "NATIONAL_PASSPORT",
        FOREIGN_PASSPORT: "FOREIGN_PASSPORT",
        SSC: "SSC",
        OTHER: "OTHER",
        SIGNATURE: "SIGNATURE",
        STATE_REGISTER_CERTIFICATE: "STATE_REGISTER_CERTIFICATE",
        COMPANY_TAX_CODE: "COMPANY_TAX_CODE",
        COMPANY_LICENSE: "COMPANY_LICENSE",
        COMPANY_REGISTRY_NUMBER: "COMPANY_REGISTRY_NUMBER",
        SHAREHOLDER_REGISTRY: "SHAREHOLDER_REGISTRY",
        UBO_DECLARATION: "UBO_DECLARATION",
        DIRECTOR_APPOINTMENT_RESOLUTION: "DIRECTOR_APPOINTMENT_RESOLUTION",
        LEGAL_ENTITY_IDENTIFIER: "LEGAL_ENTITY_IDENTIFIER"
    },
    CUSTOMER_TYPE:{
        LEGAL:"LEGAL",
        INDIVIDUAL:"INDIVIDUAL",
        PRIVATE_ENTREPRENEUR:"PRIVATE_ENTREPRENEUR",
        FINANCIAL_COMPANY:"FINANCIAL_COMPANY",
        NON_FINANCIAL_COMPANY:"NON_FINANCIAL_COMPANY"
    },
    CustomerTypes: [
        { label: 'customer-types.individual', value: 'INDIVIDUAL' },
        { label: 'customer-types.private_entrepreneuer', value: 'PRIVATE_ENTREPRENEUR' },
        { label: 'customer-types.legal', value: 'LEGAL' },
        { label: 'customer-types.financial_company', value: 'FINANCIAL_COMPANY' },
        { label: 'customer-types.non_financial_company', value: 'NON_FINANCIAL_COMPANY' },
    ],
    IdentityTypes:[
        {value:"ID_CARD", label: "identity-types.id-card"},
        {value:"NATIONAL_PASSPORT", label: "identity-types.national-passport"},
        {value:"FOREIGN_PASSPORT", label: "identity-types.foreign-passport"},
        {value:"SSC", label: "identity-types.ssc"},
        {value:"STATE_REGISTER_CERTIFICATE", label: "identity-types.state-register-certificate"},
        {value:"COMPANY_TAX_CODE", label: "identity-types.company-tax-code"},
        {value:"COMPANY_LICENSE", label: "identity-types.company-license"},
        {value:"COMPANY_REGISTRY_NUMBER", label: "identity-types.company-registry-number"},
        {value:"SHAREHOLDER_REGISTRY", label: "identity-types.shareholder-registry"},
        {value:"UBO_DECLARATION", label: "identity-types.ubo-declaration"},
        {value:"DIRECTOR_APPOINTMENT_RESOLUTION", label: "identity-types.director-appointment-resolution"},
        {value:"LEGAL_ENTITY_IDENTIFIER", label: "identity-types.legal-entity-identifier"},
        {value:"OTHER", label: "identity-types.other"}
    ],
    Genders: [
        { value: "MALE", label: "gender.male" },
        { value: "FEMALE", label: "gender.female" },
        { value: "OTHER", label: "gender.other" }
    ],
    NamePrefixes: [
        { value: "Mr", label: "Mr" },
        { value: "Mrs", label: "Mrs" },
        { value: "Ms", label: "Ms" },
        { value: "Dr", label: "Dr" },
        { value: "Prof", label: "Prof" }
    ],
    AddressTypes: [
        {value:"HOME", label: "address-types.home"},
        {value:"WORK", label: "address-types.work"},
        {value:"RESIDENCE", label: "address-types.residence"},
        {value:"EMPLOYER", label: "address-types.employer"},
        {value:"OTHER", label: "address-types.other"},
    ],
    EducationTypes:[
        {value:"SECONDARY_SCHOOL", label: "education.secondary"},
        {value:"BACHELOR", label: "education.bachelor"},
        {value:"MASTER", label: "education.master"},
        {value:"PHD", label: "education.phd"},
        {value:"OTHER", label: "education.other"}
    ],
    FamilyStatusTypes:[
        {value: "SINGLE", label: "family-statuses.single"},
        {value: "MARRIED", label: "family-statuses.married"},
        {value: "DIVORCED", label: "family-statuses.divorced"},
        {value: "WIDOW", label: "family-statuses.widow"},
        {value: "OTHER", label: "family-statuses.other"}
    ],
    Status: [
        { value: "ACTIVE", label: "customer-statuses.active" },
        // { value: "WAITING_FOR_APPROVAL", label: "Waiting for Approval" },
        { value: "INACTIVE", label: "customer-statuses.inactive" }
    ],
    AccountStatus:[
        {value:"ACTIVE", label: "account-statuses.active"},
        {value:"INACTIVE", label: "account-statuses.inactive"},
        {value:"BLOCKED", label: "account-statuses.blocked"},
        {value:"PENDING", label: "account-statuses.pending"},
        {value:"DORMANT", label: "account-statuses.dormant"},
        {value:"UNCLAIMED", label: "account-statuses.unclaimed"},
        {value:"CLOSED", label: "account-statuses.closed"},
        {value:"OTHER", label: "account-statuses.other"}
    ],
    TransactionTypes:[
        {value:"DEBIT", label: "transaction-types.debit"},
        {value:"CREDIT", label: "transaction-types.credit"},
        {value:"REVERSAL", label: "transaction-types.reversal"},
        {value:"OTHER", label: "transaction-types.other"}
    ],
    LoanRepaymentTypes:[
        {value:"NEXTPAYMENT", label: "loan-repayment-types.nextpayment"},
        {value:"FULLPAYMENT", label: "loan-repayment-types.fullpayment"}
    ],

}
